import { render } from "./SectionCourses.vue?vue&type=template&id=8dabfec6&scoped=true"
import script from "./SectionCourses.vue?vue&type=script&lang=js"
export * from "./SectionCourses.vue?vue&type=script&lang=js"

import "./SectionCourses.vue?vue&type=style&index=0&id=8dabfec6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dabfec6"]])

export default __exports__